module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "gv-scuoladigitale-info-conn gv-inverted-color-scheme",
    attrs: {
      "id": "gv-scuoladigitale-info-conn"
    }
  }, [_vm._c('div', {
    directives: [{
      name: "draggable",
      rawName: "v-draggable"
    }],
    staticClass: "gv-scuoladigitale-info-conn-title gv-color-scheme",
    attrs: {
      "id": "gv-scuoladigitale-info-conn-title"
    }
  }, [_vm._c('b', [_vm._v("Risultato Info")]), _vm._v(" "), _vm._c('el-button', {
    staticClass: "gv-close gv-color-scheme",
    attrs: {
      "icon": "el-icon-close",
      "type": "button",
      "title": "Chiudi Panello"
    },
    on: {
      "click": _vm.closePanel
    }
  })], 1), _vm._v(" "), _vm._c('div', {
    staticClass: "gv-scuoladigitale-info-conn-body",
    attrs: {
      "id": "gv-scuoladigitale-info-conn-body"
    }
  }, [_vm._c('div', {
    staticClass: "gv-scuoladigitale-info-conn-result"
  }, [_vm._c('div', {
    staticClass: "gv-scuoladigitale-info-conn-scuola"
  }, [_vm._c('TABLE', {
    attrs: {
      "width": "92%"
    }
  }, [_vm._c('TBODY', [_vm._c('TR', [_vm._c('TD', {
    staticClass: "fogliaL"
  }, [_vm._v("Istituto")]), _vm._v(" "), _vm._c('TD', {
    staticClass: "foglia"
  }, [_vm._v(_vm._s(_vm.properties.ISTITUTO))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
    staticClass: "fogliaL"
  }, [_vm._v("Indirizzo")]), _vm._v(" "), _vm._c('TD', {
    staticClass: "foglia"
  }, [_vm._v(_vm._s(_vm.properties.INDIRIZZO) + " - " + _vm._s(_vm.properties.CAP) + " - " + _vm._s(_vm.properties.COMUNE))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
    staticClass: "fogliaL"
  }, [_vm._v("Telefono")]), _vm._v(" "), _vm._c('TD', {
    staticClass: "foglia"
  }, [_vm._v(_vm._s(_vm.properties.TELEFONO))])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
    staticClass: "fogliaL"
  }, [_vm._v("Sede")]), _vm._v(" "), _vm._c('TD', {
    staticClass: "foglia"
  }, [_vm._v("\n                        " + _vm._s(_vm.tipoSede) + "\n                    ")])], 1), _vm._v(" "), _vm._c('TR', [_vm._c('TD', {
    staticClass: "fogliaL"
  }, [_vm._v("Connessione")]), _vm._v(" "), _vm._c('TD', {
    staticClass: "foglia"
  }, [_vm._c('A', {
    attrs: {
      "href": _vm.tipoConnURL,
      "target": "_blank"
    }
  }, [_vm._c('B', [_vm._v("Connettività " + _vm._s(_vm.tipoConn))])], 1)], 1)], 1)], 1)], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9b27da4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScuolaDigitaleInfoConn.vue
// module id = 902
// module chunks = 39